import { render, staticRenderFns } from "./existingCases.vue?vue&type=template&id=0a554c02&lang=pug&"
import script from "./existingCases.vue?vue&type=script&lang=js&"
export * from "./existingCases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/src/SelfService.App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a554c02')) {
      api.createRecord('0a554c02', component.options)
    } else {
      api.reload('0a554c02', component.options)
    }
    module.hot.accept("./existingCases.vue?vue&type=template&id=0a554c02&lang=pug&", function () {
      api.rerender('0a554c02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/application/existingCases/existingCases.vue"
export default component.exports